import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ReplayIcon from "@mui/icons-material/Replay";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import CloseIcon from '../../animation/jobs/Cross icon.svg';
import BookmarkIcon from '../../animation/jobs/My jobs icon.svg';
import ShowAllIcon from '../../animation/jobs/Show all icon.svg';
import { store } from "./../../redux/store";
import "./Mainjob.css";
import { ServiceApi } from "./Service/ServiceApi";
import jobUtils from './utils/jobUtils';

const MainJob = () => {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [hiddenJobs, sethiddenJobs] = useState([]);
  const history = useHistory()

  const token = localStorage.getItem("token");

  const profiledetail = store.getState().profile;
  

  useEffect(() => {
    const fetchapi = async () => {
      try {
        setLoading(true);
        const result = await ServiceApi.MainPageApi(token);
        setData(result.data);
      } catch (err) {
        console.error("Error fetching initial data:", err);
        setError("Failed to load data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchapi();
  }, []);


  const handleRemoveJob = async (job) => {
    try {
      await ServiceApi.DeleteApi(token, job.id);
      if (!hiddenJobs.includes(job.id)) {
        sethiddenJobs((prev) => [...prev, job.id]);
      }
    } catch (error) {
      console.error("Delete error:", error);
    }
  };


  const redirectjob = (job) => {
    if (!job || !job.id) return;
    const encodedTitle = encodeURIComponent(job.title || "");
    history.push(`/jobs/${job.id}?from=main&related_title=${encodedTitle}`);
  };

  const handleRestore = (job) => {
    sethiddenJobs((prev) => prev.filter((id) => id !== job.id));
  };



  return (
    <div className="main-job-page">
      {/* Left Sidebar */}
      <div className="left-section">
        {/* Profile Card */}
        <div className="profile-card">
          {/* <img className="banner-image" src="/Image/jobimage.png" /> */}
         {profiledetail.userCoverPic?(
           <img
               src={profiledetail.userCoverPic}
               className="banner-image"
           />
         ):(
 
          <img src={"/Image/Profile/cover.svg"} className="banner-image"/>
         )}
          <div className="profile-info">

            <div className="avatar">
              {profiledetail.userProfilePic ? (
                <img
                  src={profiledetail.userProfilePic}
                />
              ) : (
                <AccountCircleIcon style={{ fontSize: "108px", color: "#A9A9A9" }} />
              )}
            </div>
            <>
              <div className="info">
                <h2 className="name">
                  {profiledetail.name}
                </h2>

                {profiledetail.designation
                  && <p className="role">{profiledetail.
                    designation
                  }</p>}
                {profiledetail.address && <p className="location">{profiledetail.address}</p>}
                {profiledetail.organisation && <p className="company">{profiledetail.organisation}</p>}
              </div>
            </>
          </div>
        </div>

        {/* Preferences */}
        <div className="preference-job-box">
          {/* <div className="item">
            <ListIcon className="icon" />
            <span>Preferences</span>
          </div> */}
          <div className="item">
            <img src={BookmarkIcon} className="icon" />
            <Link to="/savejob">My Jobs</Link>
          </div>
        </div>
      </div>

      {/* Right Section */}
      <div className="right-section">
        <h2 className="title">Top job picks for you</h2>
        <p className="subtitle">
          Based on your profile, preferences, and activity like applies, searches, and saves
        </p>

        {/* Job List */}
        {loading ? (
          <div className="loader-container">
            <CircularProgress style={{ color: "#F33070" }} />
          </div>
        ) : error ? (
          <p>{error}</p>
        ) : data && data.length > 0 ? (
          data.slice(0, 5).map((job) => (
            <div
              className={`job-card ${hiddenJobs.includes(job.id) ? "hidden" : ""}`} key={job.id}
            >
              {job.CompanyData.company_logo ? (
                <img
                  src={jobUtils.decodeIfProxy(job?.CompanyData?.company_logo) || '/Image/fallback-company.png'}
                  alt={`${job?.CompanyData?.company_name ?? 'Company'} logo`}
                  className="company_logo"
                  onError={(e) => {
                    const img = e.currentTarget;
                    // if current src still contains "/media/" try switching to the decoded original host
                    if (img.src && img.src.includes('/media/')) {
                      const decoded = jobUtils.decodeIfProxy(job?.CompanyData?.company_logo);
                      if (decoded && decoded !== img.src) {
                        img.onerror = null; // prevent infinite loop
                        img.src = decoded;
                        return;
                      }
                    }
                    // final fallback
                    img.onerror = null;
                    img.src = '/Image/fallback-company.png';
                  }}
                />
              ) : (
                <div
                  className="logo-placeholder"
                >
                  {(job.CompanyData.company_name && job.CompanyData.company_name.charAt(0).toUpperCase()) ||
                    (job.title && job.title.charAt(0).toUpperCase()) ||
                    "J"}
                </div>
              )}

              <div className="job-info"  onClick={() => redirectjob(job)}>
                <h3 className="job-title">{job.title || "No Title"}</h3>
                <p className="company" >
                  {job.CompanyData.company_name || "Unknown Company"}
                  {job?.remote && job.remote !== "NA" && (
                    job.remote === "onsite" 
                      ? "(On-Site)" 
                      : job.remote === "remote" 
                        ? "(Remote)" 
                        : null
                  )}

                </p>

                {hiddenJobs.includes(job.id) ?
                  <p className="hiddenMessage">
                    We won’t show you this job again.</p>
                  :
                  <p className="recommend">
                    Highly Recommended for your profile
                  </p>
                }

              </div>

              <span
                className="close"
                onClick={() => handleRemoveJob(job)}
                style={{ cursor: "pointer" }}
              >
                {!hiddenJobs.includes(job.id) ? <img src={CloseIcon} className="close-icon" />
                  :
                  <ReplayIcon sx={{ color: "#666", cursor: "pointer" }} onClick={() => handleRestore(job)} />
                }
              </span>

            </div>


          ))
        ) : (
          <p>No jobs available</p>
        )}

        {/* Show All Button */}
        <Link to="/jobs">
          <button className="show-all">
            Show all <span className="arrow"><img src={ShowAllIcon} width={18} height={18} /></span>
          </button>
        </Link>
      </div>
    </div>

  );
};

export default MainJob;